import { useTranslation } from 'src/hooks';

interface Props {
  price: number | null;
}

export const PriceCell = ({ price }: Props) => {
  const { t } = useTranslation();

  if (!price) {
    return <div>{t('defaults.grid.price_free')}</div>;
  }

  return <div>{`${price.toFixed(2)}€`}</div>;
};
